import React from "react";
import { Tag } from "antd";
import {
  AndroidOutlined,
  AppleOutlined,
  ChromeOutlined,
  MobileOutlined,
} from "@ant-design/icons";
import { chartColors } from "components/charts/constants";

interface IProps {
  platform: "android" | "ios" | "web" | "mweb" | "app";
}

const TagPlatform = (props: IProps) => {
  const { platform } = props;

  switch (platform) {
    case "android":
      return (
        <Tag color={chartColors[11]}>
          <AndroidOutlined /> Android
        </Tag>
      );
    case "ios":
      return (
        <Tag color={chartColors[1]}>
          <AppleOutlined /> iOS
        </Tag>
      );
    case "web":
      return (
        <Tag color={chartColors[19]}>
          <ChromeOutlined /> Web
        </Tag>
      );
    case "mweb":
      return (
        <Tag color={chartColors[17]}>
          <MobileOutlined /> MWeb
        </Tag>
      );
    case "app":
      return (
        <Tag color={chartColors[17]}>
          <MobileOutlined /> App
        </Tag>
      );
    default:
      return platform;
  }
};

export default React.memo(TagPlatform);
